// extracted by mini-css-extract-plugin
export default {"header":"Header_header__3bxrR","link":"Header_link__4ANhZ","user":"Header_user__lbBL2"};